// extracted by mini-css-extract-plugin
module.exports = {"responsiveHeader":"ResponsiveHeader_responsiveHeader__1t2h_","responsiveHeader_portrait":"ResponsiveHeader_responsiveHeader_portrait__2pMpQ"};